import { useQuery } from "@apollo/client"
import { GET_TOURNAMENT_ROUND, GET_TOURNAMENT_ROUND_SIMPLE } from "../queries/tournamentRound"

export const useTournamentRound = (roundId: number) => {
  const { data, loading, error, refetch } = useQuery(GET_TOURNAMENT_ROUND, {
    variables: { id: roundId },
    errorPolicy: "all",
    skip: !roundId,
  })

  return {
    round: data?.TournamentRound,
    loading,
    error,
    refetch,
  }
}

export const useTournamentRoundSimple = (roundId: number) => {
  const { data, loading, error, refetch } = useQuery(GET_TOURNAMENT_ROUND_SIMPLE, {
    variables: { id: roundId },
    errorPolicy: "all",
    skip: !roundId,
  })

  return {
    round: data?.TournamentRound,
    loading,
    error,
    refetch,
  }
}
